import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { AccountWidgetItemViewModel } from '../../ViewModels/AccountWidgetItemViewModel';
import AccWidgetDnDPlace from '@styles/webdesktop/Icons/accWidgetDnDPlace.svg';
export class AccountWidgetItem extends WMComponent {
    constructor(props) {
        super(props, AccountWidgetItemViewModel);
        this.DragNDropEnd = this.DragNDropEnd.bind(this);
        this.accWidgetTileOver = this.accWidgetTileOver.bind(this);
        this.accWidgetTileLeave = this.accWidgetTileLeave.bind(this);
    }
    DragNDropEnd() {
        this.viewModel.hovered = false;
        this.props.onItemDragNDropEnd(this.props.itemKey);
    }
    accWidgetTileOver() {
        this.viewModel.hovered = true;
    }
    accWidgetTileLeave() {
        this.viewModel.hovered = false;
    }
    render() {
        const { DragNDropInProcess } = this.props;
        if (DragNDropInProcess) {
            return this.renderDragNDropWidget();
        }
        else {
            return this.renderInfoWidget();
        }
    }
    renderDragNDropWidget() {
        const { hovered } = this.state;
        return (_jsx("div", { className: `js-accWidget-AddWidget ${hovered ? 'hovered' : ''}`.trim(), onMouseUp: this.DragNDropEnd, onMouseEnter: this.accWidgetTileOver, onMouseLeave: this.accWidgetTileLeave, children: _jsx(AccWidgetDnDPlace, {}) }));
    }
    renderInfoWidget() {
        const { tooltip, header, firstValue, firstValueColor, secondValue, secondValueColor } = this.state;
        return (_jsxs("div", { className: "js-accWidget-info", "data-tooltip": tooltip, children: [_jsx("div", { className: "js-top-infoDiv", style: { pointerEvents: 'none' }, children: header }), _jsxs("div", { className: "js-bottom-infoDiv", style: { pointerEvents: 'none' }, children: [_jsx("div", { className: firstValueColor, children: firstValue }), secondValue && (_jsxs(_Fragment, { children: [_jsx("div", { children: "/" }), _jsx("div", { className: secondValueColor, children: secondValue })] }))] })] }));
    }
}
